import React from 'react';
import { phases } from '../data/site';
import { Reveal } from './Reveal';
export function Phases() {
  return <section className="bg-ink py-24 text-paper lg:py-32" data-id="element-94" data-mp="2t7848gb12xcx">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-95" data-mp="2o73m6luh1ukl">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-96" data-mp="2o5ipoqolk1k3">
          <div className="lg:col-span-4" data-id="element-97" data-mp="2j8in4pqyhgxq">
            <Reveal data-id="element-98" data-mp="2j7r0i4fc6tjl">
              <p className="text-[11px] uppercase tracking-label text-paper/50" data-id="element-99" data-mp="2jad4ju30qqx2">Neuf &amp; rénovation</p>
              <h2 className="mt-5 font-display text-4xl leading-[1.05] tracking-tight lg:text-5xl" data-id="element-100" data-mp="2afp2ecsqppch">
                Chaque projet suit les mêmes premières étapes.
              </h2>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-paper/60" data-id="element-101" data-mp="25ehvefyf8u6v">
                L’ordre compte : un relevé juste conditionne l’esquisse, et une esquisse partagée conditionne un
                avant-projet réaliste.
              </p>
            </Reveal>
          </div>

          <ol className="lg:col-span-7 lg:col-start-6" data-id="element-102" data-mp="1rhmgi6vho8iw">
            {phases.map((phase, index) => <Reveal key={phase.title} delay={0.05 * index} data-id="element-103" data-mp="1q261u52y7iyh" data-mpi={index}>
                <li className="grid grid-cols-[3rem_1fr] gap-4 border-t border-paper/15 py-8 first:border-t-0 first:pt-0 sm:grid-cols-[4rem_1fr] sm:gap-8" data-id="element-104" data-mp="1uw0sjsgz0y72">
                  <span className="font-display text-2xl leading-none text-clay" data-id="element-105" data-mp="1l55vdt26se6u">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div data-id="element-106" data-mp="28va1c72ukq10">
                    <h3 className="font-display text-2xl leading-tight sm:text-3xl" data-id="element-107" data-mp="28sxkjx8tslpj">{phase.title}</h3>
                    <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-paper/60" data-id="element-108" data-mp="2drh63wjibvhd">{phase.text}</p>
                  </div>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}